export default {
    name: "InsertData",
    title: "Insert Data",
    icon: "mdi-database-plus",
    create() {
        return {
            name: this.title,
            description: null,
            actionType: this.name,
            table: null,
            values: [],
            output: null,
            childAction1: [],
            childAction2: []
        };
    },
};